import { UsersContainer } from './UsersContainer';

const name = 'UsersContainer';

export { UsersContainer, name };
